import { BodyCheckConfig } from 'game/extended/creatures/goblins/abilities/body_check/body_check'

export const body_check_config: Array<BodyCheckConfig> = [
    {
        available: 0,
        cooldown: 6,
        energy: 4,
        percentage: 35
    }
]